// extracted by mini-css-extract-plugin
module.exports = {"slide":"_2iqMIj"};